import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_381: DocMigration = {
  maxSchemaVersion: "0.0.381",
  description: "Migrate eave and rake frieze board settings to stacked frieze storage",
  apply(json: any) {
    const allSettingsIds = Object.keys(json.settings);
    allSettingsIds.sort((a, b) => json.settings[a].sortIndex - json.settings[b].sortIndex);

    for (const settingId of allSettingsIds) {
      const setting = json.settings[settingId];

      if (setting.type !== "ROOF_SETTINGS") {
        continue;
      }
      const { eaveFriezeBoard, rakeFriezeBoard, eaveFriezeBoardMaterial, rakeFriezeBoardMaterial } = setting;

      let steppedEaveFriezeBoard: object | undefined = undefined;
      let steppedRakeFriezeBoard: object | undefined = undefined;

      if (rakeFriezeBoard) {
        steppedRakeFriezeBoard = {
          friezeBoard: rakeFriezeBoard,
          friezeBoardMaterial: undefined,
        };
      }

      if (eaveFriezeBoard) {
        steppedEaveFriezeBoard = {
          friezeBoard: eaveFriezeBoard,
          friezeBoardMaterial: undefined,
        };
      }

      delete setting.eaveFriezeBoard;
      delete setting.rakeFriezeBoard;

      if (steppedEaveFriezeBoard) {
        setting["eaveFriezeBoard"] = [steppedEaveFriezeBoard];
      }
      if (steppedRakeFriezeBoard) {
        setting["rakeFriezeBoard"] = [steppedRakeFriezeBoard];
      }

      //convert material to legacy material
      if (rakeFriezeBoardMaterial) {
        setting["rakeFriezeBoardMaterialLegacy"] = rakeFriezeBoardMaterial;
      }
      if (eaveFriezeBoardMaterial) {
        setting["eaveFriezeBoardMaterialLegacy"] = eaveFriezeBoardMaterial;
      }

      delete setting.eaveFriezeBoardMaterial;
      delete setting.rakeFriezeBoardMaterial;
    }

    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofSettings = {} } = roof;
      const { eaveFriezeBoard, rakeFriezeBoard, eaveFriezeBoardMaterial, rakeFriezeBoardMaterial } = roofSettings;

      let steppedEaveFriezeBoard: object | undefined = undefined;
      let steppedRakeFriezeBoard: object | undefined = undefined;

      if (rakeFriezeBoard) {
        steppedRakeFriezeBoard = {
          friezeBoard: rakeFriezeBoard,
          friezeBoardMaterial: undefined,
        };
      }

      if (eaveFriezeBoard) {
        steppedEaveFriezeBoard = {
          friezeBoard: eaveFriezeBoard,
          friezeBoardMaterial: undefined,
        };
      }

      delete roofSettings.eaveFriezeBoard;
      delete roofSettings.rakeFriezeBoard;

      if (steppedEaveFriezeBoard) {
        roofSettings["eaveFriezeBoard"] = [steppedEaveFriezeBoard];
      }
      if (steppedRakeFriezeBoard) {
        roofSettings["rakeFriezeBoard"] = [steppedRakeFriezeBoard];
      }

      //convert material to legacy material
      if (rakeFriezeBoardMaterial) {
        roofSettings["rakeFriezeBoardMaterialLegacy"] = rakeFriezeBoardMaterial;
      }
      if (eaveFriezeBoardMaterial) {
        roofSettings["eaveFriezeBoardMaterialLegacy"] = eaveFriezeBoardMaterial;
      }
      delete roofSettings.eaveFriezeBoardMaterial;
      delete roofSettings.rakeFriezeBoardMaterial;

      const { roofSideOverrides = {} } = roof;

      const { START = {}, END = {}, LEFT = {}, RIGHT = {} } = roofSideOverrides;

      const {
        includeFriezeBoard: includeFriezeBoardStart,
        friezeBoard: friezeBoardStart,
        friezeBoardMaterial: friezeBoardMaterialStart,
      } = START;
      const {
        includeFriezeBoard: includeFriezeBoardEnd,
        friezeBoard: friezeBoardEnd,
        friezeBoardMaterial: friezeBoardMaterialEnd,
      } = END;
      const {
        includeFriezeBoard: includeFriezeBoardLeft,
        friezeBoard: friezeBoardLeft,
        friezeBoardMaterial: friezeBoardMaterialLeft,
      } = LEFT;
      const {
        includeFriezeBoard: includeFriezeBoardRight,
        friezeBoard: friezeBoardRight,
        friezeBoardMaterial: friezeBoardMaterialRight,
      } = RIGHT;

      delete START.includeFriezeBoard;
      delete START.friezeBoard;
      delete START.friezeBoardMaterial;
      if (includeFriezeBoardStart && friezeBoardStart) {
        START["friezeBoard"] = [
          {
            friezeBoard: friezeBoardStart,
            friezeBoardMaterial: undefined,
          },
        ];
      } else if (includeFriezeBoardStart || friezeBoardStart) {
        START["includeFriezeBoardLegacy"] = includeFriezeBoardStart || friezeBoardStart;
      }

      START["friezeBoardMaterialLegacy"] = friezeBoardMaterialStart;

      delete END.includeFriezeBoard;
      delete END.friezeBoard;
      delete END.friezeBoardMaterial;
      if (includeFriezeBoardEnd && friezeBoardEnd) {
        END["friezeBoard"] = [
          {
            friezeBoard: friezeBoardEnd,
            friezeBoardMaterial: undefined,
          },
        ];
      } else if (includeFriezeBoardEnd || friezeBoardEnd) {
        END["includeFriezeBoardLegacy"] = includeFriezeBoardEnd || friezeBoardEnd;
      }

      END["friezeBoardMaterialLegacy"] = friezeBoardMaterialEnd;

      delete LEFT.includeFriezeBoard;
      delete LEFT.friezeBoard;
      delete LEFT.friezeBoardMaterial;
      if (includeFriezeBoardLeft && friezeBoardLeft) {
        LEFT["friezeBoard"] = [
          {
            friezeBoard: friezeBoardLeft,
            friezeBoardMaterial: undefined,
          },
        ];
      } else if (includeFriezeBoardLeft || friezeBoardLeft) {
        LEFT["includeFriezeBoardLegacy"] = includeFriezeBoardLeft || friezeBoardLeft;
      }

      LEFT["friezeBoardMaterialLegacy"] = friezeBoardMaterialLeft;

      delete RIGHT.includeFriezeBoard;
      delete RIGHT.friezeBoard;
      delete RIGHT.friezeBoardMaterial;

      if (includeFriezeBoardRight && friezeBoardRight) {
        RIGHT["friezeBoard"] = [
          {
            friezeBoard: friezeBoardRight,
            friezeBoardMaterial: undefined,
          },
        ];
      } else if (includeFriezeBoardRight || friezeBoardRight) {
        RIGHT["includeFriezeBoardLegacy"] = includeFriezeBoardRight || friezeBoardRight;
      }
      RIGHT["friezeBoardMaterialLegacy"] = friezeBoardMaterialRight;

      const newStart = Object.keys(START).length > 0 ? { START: { ...START } } : {};
      const newEnd = Object.keys(END).length > 0 ? { END: { ...END } } : {};
      const newLeft = Object.keys(LEFT).length > 0 ? { LEFT: { ...LEFT } } : {};
      const newRight = Object.keys(RIGHT).length > 0 ? { RIGHT: { ...RIGHT } } : {};

      const newRoofSideOverrides = {
        ...roofSideOverrides,
        ...newStart,
        ...newEnd,
        ...newLeft,
        ...newRight,
      };

      const { roofEdgeOverrides = {} } = roof;

      let newRoofEdgeOverrides = {};

      for (const key of Object.keys(roofEdgeOverrides)) {
        const edge = { ...roofEdgeOverrides[key] };
        const { includeFriezeBoard, friezeBoard, friezeBoardMaterial } = edge;
        delete edge.includeFriezeBoard;
        delete edge.friezeBoard;
        delete edge.friezeBoardMaterial;

        if (includeFriezeBoard && friezeBoard) {
          edge["friezeBoard"] = [
            {
              friezeBoard: friezeBoard,
              friezeBoardMaterial,
            },
          ];
        } else if (includeFriezeBoard || friezeBoard) {
          edge["includeFriezeBoardLegacy"] = includeFriezeBoard || friezeBoard;
        }
        edge["friezeBoardMaterialLegacy"] = friezeBoardMaterial;
        newRoofEdgeOverrides = { ...newRoofEdgeOverrides, [key]: edge };
      }

      roofs[id] = {
        ...roof,
        roofSettings,
        roofSideOverrides: newRoofSideOverrides,
        roofEdgeOverrides: newRoofEdgeOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_381;
